import Footer from './footer.presenter';

export default function FooterPage() {
    return <Footer />;
}
